function board_filter_teachers() {
    open_course_board_filters('teachers', function(elm, filters) {
        if (filters.teachers) {
            elm.find('input:checked').removeAttr('checked');
            filters.teachers.forEach(function(id) {
                elm.find('input[value="' + id + '"]')[0].checked = true;
            });
        }
    });
    return false;
}
function board_filter_locations() {
    open_course_board_filters('locations', function(elm, filters) {
        if (filters.rooms) {
            elm.find('input:checked').removeAttr('checked');
            filters.rooms.forEach(function(id) {
                const input = elm.find('input[value="' + id + '"]');
                input[0].checked = true;

                const parent = input.parents('ul').length > 0 ? input.parents('ul') : input.parents('.row');

                if (parent.find('input:checked').length === parent.find('input').length) {
                    parent.parent().children('input')[0].checked = true;
                }
            });
        }
        elm.find('form > .checkbox-wrapper > input, form > .row > .column > input').change(function() {
            const checked = jQuery(this).is(':checked');
            jQuery(this).parent().find('input').each(function() {
                jQuery(this)[0]['checked'] = checked;
            })
        });
    });
    return false;
}
function open_course_board_filters(type, callback) {
    var $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/courses/board/' + type + '/filters',
        size: 'medium',
        onOpen: function(elm, popup) {
            const filters = getBoardFilters();

            callback(elm, filters);

            elm.find('form').submit(function(e) {
                e.preventDefault();

                setBoardFilters($(this).serializeJSON());

                popup.close();
            });
        }
    });
}